export default __webpack_public_path__ + "static/media/PA.e5ddf013.svg";